// import college1 from '../Assets/Home About Us Images/college/college1.jpeg'
import college1 from "../Assets/Home About Us Images/college/college1.jpg";
import college2 from "../Assets/Home About Us Images/college/college2.jpeg";
import college3 from "../Assets/Home About Us Images/college/college3.jpg";
import team1 from "../Assets/Home About Us Images/team/team1.JPG";
import workshop1 from "../Assets/Home About Us Images/workshop/workshop1.JPG";
import workshop2 from "../Assets/Home About Us Images/workshop/workshop2.JPG";

const aboutusinfo = [
  {
    ourcollegeimages: [college1, college2, college3],
    ourteamimages: [team1],
    ourworkshopimages: [workshop1, workshop2, workshop1,workshop2],
    whoweare:
      " The Club focuses on the development of students through working on various robotic projects and also participating in National as well as International level Competitions.",
    whatwedo:
      "To achieve excellence in the field of robotics and AI, Thus contributing to the development of the nation.",
    ourmission:
      "Team DRAIC seeks to inspire the next generation of bright minds, to cultivate an appreciation for the present technology.",
  },
];
export default aboutusinfo;
